<template>
  <div class="spl-export-proof-detail-header">
    <form-button style="grid-column: 1" @onClick="handleEditExportProof">
      Edit
    </form-button>
    <div style="grid-column: 2" />
    <form-button
      style="grid-column: 3"
      data-cy="export-proof-detail-header-excel"
      @onClick="handleDownload('Excel')">
      Excel
    </form-button>
    <form-button
      style="grid-column: 4"
      data-cy="export-proof-detail-header-pdf"
      @onClick="handleDownload('PDF')">
      PDF
    </form-button>
    <form-toggle-switch
      v-model="language"
      style="grid-column: 5"
      data-cy="export-proof-detail-header-languange"
      text-unchecked="EN"
      text-checked="DE" />
    <form-button
      style="grid-column: 6"
      data-cy="export-proof-detail-header-email"
      @onClick="handleDownload('Email')">
      Send Email
    </form-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Helpers from '@/helpers.vue'
import { round } from 'lodash'
import QuestionDialog from '@/components/shared/question-dialog.vue'
import { create } from 'vue-modal-dialogs'

const confirm = create(QuestionDialog, 'title', 'content', 'positiveText', 'negativeText')

export default {
  mixins: [Helpers],
  data () {
    return {
      language: true,
      dialogOpen: false
    }
  },
  computed: {
    ...mapState('exportProof', ['loadedExportProof', 'exportProofResult'])
  },
  methods: {
    handleEditExportProof () {
      // Goes into the edit page of the export proof
      this.$router.push('/export-proof-edit/' + this.loadedExportProof.Export_Proof_ID)
    },
    handleDownload (fileType) {
      var excelList = {
        Columns: [],
        Rows: [],
        Filter: {

        }
      }
      var selectedFields = this.loadedExportProof.Export_Proof_Layout
      var selectedFilters = this.loadedExportProof.Export_Proof_Filter
      // Loop through the columns and add them to excel object
      for (let i = 0; i < selectedFields.length; i++) {
        const field = selectedFields[i]
        excelList.Columns.push({ ID: field.Name, Header: field.Label, Type: this.getColumnType(field.Format) })
      }

      const results = this.exportProofResult
      // add the values
      for (let i = 0; i < results.length; i++) {
        var rowValues = { Value: [] }
        const result = results[i]
        for (let j = 0; j < selectedFields.length; j++) {
          const field = selectedFields[j]
          rowValues.Value.push(this.formatField(result[field.Name], field.Format))
        }
        excelList.Rows.push(rowValues)
      }
      var filters = { }
      filters.From_Date = selectedFilters.From_Date
      filters.To_Date = selectedFilters.To_Date
      filters.Customers = selectedFilters.Customers
      filters.Countries = selectedFilters.Countries
      filters.MRN_Number = selectedFilters.MRN_Number
      filters.Delivery_Note_Number = selectedFilters.Delivery_Note_Number
      filters.Counter_Number = selectedFilters.Counter_Number
      filters.Parcel_Status = selectedFilters.Parcel_Status
      filters.Service_Levels = selectedFilters.Service_Levels
      filters.Current_Event_Infos = selectedFilters.Current_Event_Infos
      filters.To_Mail_List = selectedFilters.To_Mail_List

      excelList.Filter = filters
      // Call the excel download helper
      if (fileType === 'Excel') {
        this.getExportProofExcelDownload(excelList, 'SPLIT_Export_Proof.xlsx')
      } else if (fileType === 'PDF') {
        this.getExportProofPDFDownload(excelList, 'SPLIT_Export_Proof.pdf')
      } else {
        this.sendEmail(excelList, filters.To_Mail_List)
      }
    },
    async sendEmail (excelList, emailList) {
      if (this.dialogOpen) {
        return
      }
      this.dialogOpen = true
      if (await confirm('You are sending an email to:', emailList, 'Send Email', 'Cancel')) {
        this.sendExportProofEmail(excelList, this.language ? 'DE' : 'EN')
        this.dialogOpen = false
      } else {
        this.dialogOpen = false
      }
    },
    // Special formatting for fields
    formatField (field, type) {
      if (type === 'Number.2') {
        return round(field, 2).toFixed(2)
      } else if (type === 'Number.3') {
        return round(field, 3).toFixed(3)
      } else if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Timestamp') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      }
      // empty fields will be removed
      if (field == null) {
        return ''
      }
      return field
    },
    getColumnType (fieldType) {
      // Converts the formats into excel compatible ones
      // "Number", "DateTime", "Text", "Boolean"
      if (fieldType) {
        switch (fieldType) {
          case 'Number':
          case 'Number.2':
          case 'Number.3':
            return 'Number'

          case 'Boolean' :
            return 'Boolean'

          case 'Date':
          case 'Timestamp':
            return 'DateTime'

          case 'String':
          default: {
            return 'Text'
          }
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';
  .spl-export-proof-detail-header {
    padding: 0 70px;
    display: grid;
    grid-template-columns: 100px auto 100px 100px 100px 120px;
    margin-bottom: 15px;
    .spl-button {
      margin: 0;
      margin-left: 8px;
    }
    .switch {
      margin: 0;
      margin-top: 3px;
      margin-left: 4px;
      margin-right: 4px;
    }
  }
</style>
